import _classCallCheck from "/codebuild/output/src3924087242/src/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src3924087242/src/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src3924087242/src/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/codebuild/output/src3924087242/src/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/codebuild/output/src3924087242/src/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Action } from "../../internal/Action.js";
import { Qualifier } from "../../internal/qualifier/Qualifier.js";
/**
 * @description OpacityAction class, used to define the opacity of an asset
 * @memberOf Actions.Adjust
 * @extends SDK.Action
 */

var OpacityAdjustAction = /*#__PURE__*/function (_Action) {
  _inherits(OpacityAdjustAction, _Action);

  var _super = _createSuper(OpacityAdjustAction);

  function OpacityAdjustAction(level) {
    var _this;

    _classCallCheck(this, OpacityAdjustAction);

    _this = _super.call(this);
    _this._actionModel = {
      actionType: 'opacity'
    };
    _this.level = level;
    _this._actionModel.level = level;

    _this.addQualifier(new Qualifier('o', level));

    return _this;
  }

  _createClass(OpacityAdjustAction, null, [{
    key: "fromJson",
    value: function fromJson(actionModel) {
      var level = actionModel.level; // We are using this() to allow inheriting classes to use super.fromJson.apply(this, [actionModel])
      // This allows the inheriting classes to determine the class to be created

      return new this(level);
    }
  }]);

  return OpacityAdjustAction;
}(Action);

export { OpacityAdjustAction };